import toMap from '~/misc/toMap';

export default toMap([
  'VERIFY_EMAIL',
  'VERIFY_SEND_PHONE_CODE',
  'VERIFY_PHONE'
]);



// WEBPACK FOOTER //
// ./src/modules/verify/types.js